import { useAuth } from '../lib/auth.js';
import SignInScreen from './SignInScreen.jsx';
import { supabaseConfigured } from '../lib/supabase.js';

// Gates private routes behind sign-in. Pages that should be PUBLIC (like
// /u/:slug profile pages) should NOT be wrapped in this — render them
// directly in App.jsx.
export default function AuthGate({ children }) {
  const { user, loading } = useAuth();

  if (!supabaseConfigured) {
    return (
      <div className="hb-empty">
        <h2>Backend not configured</h2>
        <p>
          Add <code>VITE_SUPABASE_URL</code> and <code>VITE_SUPABASE_ANON_KEY</code>
          to your <code>.env</code> file to enable sign-in.
        </p>
      </div>
    );
  }

  if (loading) {
    return <div className="hb-empty">Loading the store…</div>;
  }

  if (!user) {
    return <SignInScreen />;
  }

  return children;
}
